import { render } from "./SubdivisionHistory.vue?vue&type=template&id=0dbccddc"
import script from "./SubdivisionHistory.vue?vue&type=script&lang=js"
export * from "./SubdivisionHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__